module.exports = __webpack_public_path__ + "static/img/about_SAP_h5_zh.88e4498.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_SAP_h5_zh.png
// module id = OXaV
// module chunks = 34